import axios from "axios";



export const instance = axios.create({
  baseURL: `https://parking.bukovel.com/`,
});

export const fetchData = (url: string, options?: any) => {
  return new Promise((resolve, reject) => {
    instance
      .get(url, options)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response);
        } else {
          reject(error);
        }
      });
  });
};
